"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_RESENT_COOLDOWN_MINUTES = exports.UserStatus = exports.UserRoles = exports.USER_ROLE_PROVIDER_ADMIN = exports.USER_ROLE_MASTER = exports.USER_ROLE_TEMPLATE = exports.USER_ROLE_PROVIDER = exports.USER_ROLE_EXPERT = exports.USER_ROLE_VALIDATOR = exports.USER_ROLE_USER = void 0;
exports.USER_ROLE_USER = "user";
exports.USER_ROLE_VALIDATOR = "validator";
exports.USER_ROLE_EXPERT = "coach";
exports.USER_ROLE_PROVIDER = "provider";
exports.USER_ROLE_TEMPLATE = "template";
exports.USER_ROLE_MASTER = "master_admin";
exports.USER_ROLE_PROVIDER_ADMIN = "provider_admin";
var UserRoles;
(function (UserRoles) {
    UserRoles["user"] = "user";
    UserRoles["approver"] = "validator";
    UserRoles["expert"] = "coach";
    UserRoles["provider"] = "provider";
    UserRoles["template"] = "template";
    UserRoles["master"] = "master_admin";
    UserRoles["providerAdmin"] = "provider_admin";
})(UserRoles || (exports.UserRoles = UserRoles = {}));
exports.UserStatus = {
    ACTIVE: 1,
    INACTIVE: 0,
    DEACTIVATED: -1,
};
exports.EMAIL_RESENT_COOLDOWN_MINUTES = 3 * 60 * 1000;
